<template>
    <div class="wrapper">
        <div class="title">회원탈퇴</div>
        <div class="info">
            <p class="caution">               
                ⚡회원 탈퇴 전 주의사항을 한번 확인해 주세요.
            </p> 
            <ul class="list_withdrawal">
                <li>
                    <div class="img_withdrawal">
                        <img src="@/assets/imgs/icon/icon_withdrawal01.png" border="0">
                    </div>
                    <div class="info_withdrawal">
                        <p class="setp_withdrawal">1. 회원 탈퇴 후 정보 <span>삭제</span></p>
                        <div class="text_withdrawal">
                            <p>회원 탈퇴 후 <site-info type="sitename"/>에서 제공한 정보(클럽, 아이템) 등</p>
                            <p>가입중 이용하신 <span>모든 정보가 삭제되며 복구하실 수 없습니다</span>.</p>
                        </div>
                    </div>
                </li>
               
                <li>
                    <div class="img_withdrawal">
                        <img src="@/assets/imgs/icon/icon_withdrawal03.png" border="0">
                    </div>
                    <div class="info_withdrawal">
                        <p class="setp_withdrawal">2. 커뮤니티</p>
                        <div class="text_withdrawal">
                            <p>개인 정보 및 고객센터 이용내역 등 <span>모든 회원 정보와 커뮤니티 정보도 삭제</span>됩니다.</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="img_withdrawal">
                        <img src="@/assets/imgs/icon/icon_withdrawal04.png" border="0">
                    </div>
                    <div class="info_withdrawal">
                        <p class="setp_withdrawal">3. 탈퇴 후 <span>제한</span></p>
                        <div class="text_withdrawal">
                            <p>탈퇴 처리 완료 후 해당 아이디는 <span>30일간 재가입이 불가</span>합니다.</p>
                            <p>회원 탈퇴 후 1주일 이내에는 동일한 신상정보로 가입이 불가능합니다.</p>
                        </div>
                    </div>
                </li>
                <li>
                    <div class="img_withdrawal">
                        <img src="@/assets/imgs/icon/icon_withdrawal05.png" border="0">
                    </div>
                    <div class="info_withdrawal">
                        <p class="setp_withdrawal">4. 개인 정보 보관</p>
                        <div class="text_withdrawal">
                            <p>탈퇴 처리후 개인 정보 취급방침의 개인 정보 보유 및 이용기간에 따라</p>
                            <p>탈퇴 일로부터 <span>30일간 보관되며 30일 이후 완전히 삭제</span>됩니다.</p>
                        </div>
                    </div>
                </li>
            </ul>           
        </div>
        <div class="part_bottom">
            <div class="btn_wrap">
                <base-button-sm mode="orange" @click="leave_service_confirm()">회원탈퇴</base-button-sm>
            </div>            
        </div>
    </div>
</template>
<script>
import { auth } from '@/components/mixins/auth.js';
export default {
    name:'leave_service',
    props:[
        
    ],
    data(){
        return{

        }
    },
    mixins:[
        auth
    ],
    components:{

    },
    mounted() {
    },
    methods:{
        leave_service_confirm(){
            if(confirm('위 내용을 확인 하였으며 정말 탈퇴 하시겠습니까?'))
            {
                //탈퇴처리 후 로그아웃;               
                this.leave_service();
            }else{
                return;
            }
        },
        async leave_service()
        {
            this.authCheck();   
            
            try{
                const response = await this.$store.dispatch("leave_service", {user_id: this.user.id});
                
                let type_status = "info";
                if(response.status_code !== 200)
                {
                    type_status = "error";
                }
                this.$flashMessage.show({
                    type: type_status,
                    title: response.message,
                    message: response.message,
                });
                //로그아웃
                this.$store.dispatch("logout");
                window.location.reload();
            }catch(error)
            {
                console.log(error.response);   
                 this.$flashMessage.show({
                    type: "error",
                    title: error.response.data.message,
                    message: "탈퇴신청 에러",
                }); 
            }
            
        }
        
    }
}
</script>
<style lang="scss" scoped>
.wrapper{
    padding:20px;
    p{
        margin: 0;
        padding: 0;
    }
    .title{
        font-weight:bold;
        font-size:2em;
        text-align:center;    
    }
    .info{
        margin-top:30px;
        .caution{
            padding:10px;
        }
        .list_withdrawal{
             div {
                display: inline-block;
                float: left;
            }
            li{
                border: 1px solid #dfdfe1;
                margin-bottom: 10px;
                box-shadow: 0 2px #e5e5e9;
                overflow: hidden; 
                .img_withdrawal {
                    width: 100px;
                    padding: 10px;
                    background-color: #efe9e3;
                    border: 1px solid #ffffff;
                    border-right: none;
                    box-sizing: content-box;
                }
                .info_withdrawal {                    
                    height: 100px;
                    padding: 10px;
                    color: #666c85;
                    border: 1px solid #ffffff;
                    border-left: none;
                    .setp_withdrawal {
                        font-family: 'Malgun Gothic';
                        color: #4b4b4b;
                        font-size: 20px;
                        font-weight: bold;
                    }
                    span {
                        color: #ff4500;
                    }
                    .text_withdrawal {
                        line-height: 22px;
                        padding-left: 24px;
                        margin-top: 8px;
                       
                    }
                }    
            }
        }
    }
    .part_bottom{
        margin-top:20px;
        display:flex;
        justify-content:center;
        .btn_wrap{
            line-height:30px;
        }
    }

}
</style>